import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { c as _c } from "react-compiler-runtime";
import styled from 'styled-components';
import ControlledCollaborationSidebarProvider from './ControlledCollaborationSidebarProvider';
import useCollaborationSidebarProps from '../hooks/useCollaborationSidebarProps';
import AsyncExpandableCollaborationSidebar from '../features/floatingSidebar/components/ExpandableCollaborationSidebar/AsyncExpandableCollaborationSidebar';
import AsyncCollaborationSidebarDropArea from '../features/floatingSidebar/components/CollaborationSidebarDropArea/AsyncCollaborationSidebarDropArea';
import { Flex } from 'foundations-components/components/Flex';
import ChildrenErrorBoundary from './errors/ChildrenErrorBoundary';

/**
 * This component assumes collaborationSidebarState and
 * onUpdateCollaborationSidebarState are passed in. See
 * LayoutWithCollaborationSidebar for example
 * implementation
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageContents = styled.div.withConfig({
  displayName: "ControlledLayoutWithCollaborationSidebar__PageContents"
})(["min-width:0;flex:1 1 auto;"]);
function PageLayout({
  children
}) {
  'use no memo';

  const {
    pageContentRef,
    setIsPageContentRefSet,
    withoutSidebar
  } = useCollaborationSidebarProps(); // TODO can we remove need for these?

  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "stretch",
    blockSize: "100%",
    flexGrow: 1,
    children: [/*#__PURE__*/_jsx(PageContents, {
      ref: ref => {
        // React compiler does not like writing to a ref returned from a hook
        pageContentRef.current = ref;
        setIsPageContentRefSet(true);
      },
      children: children
    }), /*#__PURE__*/_jsx(AsyncExpandableCollaborationSidebar, {}), withoutSidebar ? null : /*#__PURE__*/_jsx(AsyncCollaborationSidebarDropArea, {})]
  });
}
export default function ControlledLayoutWithCollaborationSidebar(t0) {
  "use memo";

  const $ = _c(11);
  let children;
  let props;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      children
    } = _t);
    props = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children) {
    t1 = /*#__PURE__*/_jsx(PageLayout, {
      children: children
    });
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== t1) {
    t2 = /*#__PURE__*/_jsx(ChildrenErrorBoundary, {
      fingerprint: "controlled-layout-with-collaboration-sidebar",
      originalChildren: children,
      children: t1
    });
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t2) {
    t3 = /*#__PURE__*/_jsx(ControlledCollaborationSidebarProvider, Object.assign({}, props, {
      children: t2
    }));
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}